import { Injectable } from '@angular/core';
import { Observable, Subscription } from 'rxjs';

import { WatchlistService } from 'src/core/services/watchlist.service';

@Injectable()
export class LegacyWatchlistService {
  public watchlistCounter = 0;
  public issueListCounter = 0;

  public watchlistConfiguration: any = [];
  public watchlistConfigurationDetail: any = [];
  public triggerConfiguration: any;

  public triggerSuscription: Subscription;

  constructor(private watchlistService: WatchlistService) {}

  init() {
    this.watchlistCounter = this.watchlistConfiguration.watchlists.length;
  }

  subscribeToWatchlists(): Observable<any> {
    return this.watchlistService.getWatchList();
  }

  /*   subscribeToWatchlistsDetail(): Observable<any> {
    return this.watchlistService.getWatchListDetail({
      watchlistType: [],
    });
  } */

  // changeStore(ACTION_TYPE: any) {
  //   this.store.dispatch({
  //     type: ACTION_TYPE,
  //     payload: this.watchlistConfiguration
  //   });
  // }
  // changeStoreDetail(ACTION_TYPE: any) {
  //   this.store.dispatch({
  //     type: ACTION_TYPE,
  //     payload: this.watchlistConfigurationDetail
  //   });
  // }
  // changeWatchListConfig(ACTION_STORE: any, trigger: boolean = false) {
  //   this.store.dispatch({
  //     type: ACTION_STORE,
  //     payload: this.watchlistConfiguration
  //   });
  //   if (trigger) {
  //     this.doAction();
  //   }
  // }

  // doAction() {
  //   this.store.dispatch({
  //     type: TRIGGER_WATCHLIST_ACTION,
  //     payload: true
  //   });
  // }

  validaNuevaWatchList(nuevaWatchList: string): boolean {
    let existe = false;
    for (const i of this.watchlistConfiguration.watchlists) {
      if (i.watchlistName.toLowerCase() === nuevaWatchList.toLowerCase()) {
        existe = true;
        break;
      }
    }
    return existe;
  }

  renameWatchList(
    idWatchListActive: number,
    newWatchListName: string,
    configuration?: string,
  ): Observable<any> {
    const newNameWatchlist: any = {
      watchListTypeId: idWatchListActive,
      configuration,
      title: newWatchListName,
    };
    return this.watchlistService.renameWatchList(newNameWatchlist);
  }

  addWatchlist(
    nombreWatchList: string,
    configuration: string,
  ): Observable<any> {
    if (this.watchlistCounter < 5) {
      const dId = 0;
      const newWatchlist2: any = {
        watchListTypeId: 1,
        configuration,
        title: nombreWatchList,
      };
      return this.watchlistService.addWatchList(newWatchlist2);
    }
  }

  removeWatchlist(idWatchListActive: number): Observable<any> {
    return this.watchlistService.deleteWatchList(idWatchListActive);
  }

  removeIssue(id: number, issueString: string): Observable<any> {
    return this.watchlistService.deleteIssueWatchList(issueString, id);
  }

  pushNewIssueInWatchlist(issue: string, id: number): Observable<any> {
    return this.watchlistService.addIssueWatchList(issue, id);
  }

  getWatchlistDetail(id: number): Observable<any> {
    return this.watchlistService.getWatchListDetail({
      watchListType: id,
      isOnLine: true,
    });
  }
}
